export default "__VITE_ASSET__BOlzqIxh__"